import React, { useState } from "react";
import "./user_management.scss";
import UserCard from "./UserCard";
import { useEffect } from "react";
import { Grid, Container } from "@mui/material";
import EmailValidator from "email-validator";
import Box from "@mui/material/Box";
import { Person } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { motion } from "framer-motion";
import UserDialog from "../../components/comman/dialogContent/DialogUser";
import MessageDialog from "../../components/comman/dialogMsg/DialogMsg";
import { getAllUsers } from "../../redux/actions/user.actions";
import ShowUserModal from "./ShowData";
import CreateCampaignCard from "../campaigns/component/CardComponent";
import { toast } from "react-hot-toast";
import CountUp from "react-countup";
const { get_current_date } = require("../../utils/utilities");

const UserManagement = () => {
	//#region DilogBox
	const dispatch = useDispatch();
	const host = `${process.env.REACT_APP_BASE_URL_VMS}`;
	const [open, setOpen] = React.useState(false);
	const currentDateTime = get_current_date();
	const [role, setRole] = useState("");
	const [action, setAction] = useState("Add");
	const [roles, setRoles] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [showData, setShowData] = useState({});

	const { user } = useSelector((state) => state.authReducer);
	const { users } = useSelector((state) => state.userReducer);
	const totalUser = users.length;

	const { user_roleid } = user;

	const user_id = user.user_id;


	const totalSuperAdmin = users.filter((user) => user.user_roleid === 1);
	const totalAdmin = users.filter((user) => user.user_roleid === 2);
	const totalAlliance = users.filter((user) => user.user_roleid === 3);
	const totalCampaign = users.filter((user) => user.user_roleid === 4);
	const totalAudit = users.filter((user) => user.user_roleid === 5);
	const [alertMessage, setAlertMessage] = useState("");
	const [alertType, setAlertType] = useState("success");
	const [dialogTitle, setDialogTitle] = useState("Add New User");
	const [deletePopUp, setDeletePopUp] = useState(false);
	const [deleteUserName, setDeleteUserName] = useState("");

	const [newUser, setnewUser] = useState({
		user_name: "",
		user_email: "",
		password: "",
		mobile_no: "",
		user_roleid: "",
		status: 1,
		created_by: user_id,
		modified_by: user_id,
		created_at: currentDateTime,
	});


	const handleClickOpen = () => {
		setOpen(true);
		setAction("Add");
		setDialogTitle("Add New User");
	};

	const handleClose = () => {
		setnewUser({
			user_name: "",
			user_email: "",
			password: "",
			mobile_no: "",
			user_roleid: "",
			created_by: user_id,
			modified_by: user_id,
		});
		setRole("");
		setOpen(false);
		setAlertMessage("")
		setAlertType("")
		setAction("")
		setDialogTitle("")
	};




	const [error, setError] = useState({
		email_error: false,
		mobile_error: false,
		password_error: false,
		user_error: false,
		role_error: false,
	});

	//for delete users
	const deleteUser = async () => {
		const id = localStorage.getItem("deleteUserId");
		const response = await fetch(`${host}/api/v1/users/${id}`, {
			method: "DELETE",
			headers: {
				"Content-Type": "application/json",
				accessToken: localStorage.getItem("accessToken"),
			},
		});
		const json = await response.json();
		const { status } = response || "";
		if (status && status === 200) {
			localStorage.removeItem("deleteUserId");
			setDeletePopUp(false);
			setDeleteUserName("");
			toast.success("User deleted successfully!");
			dispatch(getAllUsers(true));
		} else {
			toast.error("Unable to delete user!");
			localStorage.removeItem("deleteUserId");
			setDeletePopUp(false);
			setDeleteUserName("");
		}
		localStorage.removeItem("deleteUserId");
		if (json.id !== "") {
			let Users = users.filter((e) => {
				return e.user_id !== id;
			});
			dispatch(getAllUsers());
		}
	};



	//for featch all roles
	const fetchRoles = async () => {
		const response = await fetch(`${host}/api/v1/users/roles`, {
			method: "GET", // *GET, POST, PUT, DELETE, etc.
			headers: {
				"Content-Type": "application/json",
				accessToken: localStorage.getItem("accessToken"),
			},
		}).catch((err) => {
			console.log(err.mesage);
		});

		const json = await response.json();
		setRoles(json);
	};

	useEffect(() => {
		dispatch(getAllUsers());
		if (roles) {
			fetchRoles();
		}
	}, [dispatch]);

	const handleTextFieldChange = (e) => {
		setnewUser({ ...newUser, [e.target.id]: e.target.value });
		if (e.target.id === "user_name") {
			setError((prev) => ({
				...prev,
				user_error: !isEmpty(e.target.value) ? false : "User name is required.",
			}));
		}
	};

	const validateUserForm = () => {
		const email = String(newUser.user_email || "").trim();
		const mobile = String(newUser.mobile_no || "").trim();
		const password = String(newUser.password || "");
		const name = String(newUser.user_name || "").trim();
		const userRole = String(newUser.user_roleid || "").trim();

		const nextError = {
			user_error: name ? false : "User name is required.",
			email_error: !email
				? "Email is required."
				: !EmailValidator.validate(email)
					? "Invalid Email: Enter valid email"
					: false,
			mobile_error: !mobile
				? "Mobile number is required."
				: mobile.length !== 10
					? "Error: Number must be 10 number"
					: false,
			password_error: !password
				? "Password is required."
				: password.length < 6
					? "Error: Password length must be greator 6"
					: false,
			role_error: userRole ? false : "Please select a role.",
		};

		setError(nextError);
		return !Object.values(nextError).some(Boolean);
	};
	const createUser = async () => {
		const isValid = validateUserForm();
		if (!isValid) {
			toast("Please fill all the fields", { icon: "⚠️" });
			return
		}
		if (action === "Add") {
			let response = await fetch(`${host}/api/v1/users`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					accessToken: localStorage.getItem("accessToken"),
				},
				body: JSON.stringify(newUser),
			}).catch((err) => {
				setAlertType("error");
				setAlertMessage(err);
			});
			const data = await response.json();
			if (data.success === true) {
				dispatch(getAllUsers(true));
				toast.success("User created successfully!");
			} else {
				toast.error(data.msg || "Unable to create user!");
			}
		} else {
			editUser(newUser);
		}
		handleClose();
	};

	const updateUser = (user) => {
		delete user.isdeleted;
		setnewUser(user);
		setRole(user.user_roleid);
		handleClickOpen();
		setAction("Edit");
		setDialogTitle("Edit User");

	};

	let newuser = JSON.parse(JSON.stringify(users));

	const editUser = async (user) => {
		for (let index = 0; index < users.length; index++) {
			const element = newuser[index];
			if (element.user_id === user.user_id) {
				newuser[index].user_name = user.user_name;
				newuser[index].user_email = user.user_email;
				newuser[index].mobile_no = user.mobile_no;
				newuser[index].user_roleid = user.user_roleid;
				break;
			}
		}
		try {
			for (const oldUser of users) {
				if (oldUser.user_id === user.user_id) {
					if (oldUser.user_email === user.user_email) delete user.user_email;
					if (oldUser.password === user.password) delete user.password;
				}
			}
			const response = await fetch(`${host}/api/v1/users/${user.user_id}`, {
				method: "PATCH", // GET, POST, PUT, DELETE, etc.
				headers: {
					"Content-Type": "application/json",
					accessToken: localStorage.getItem("accessToken"),
				},
				body: JSON.stringify(user),
			});
			const json = await response.json();
			const { status } = response || "";
			if (status && status === 200) {
				setAlertType("success");
				let updateUser = true
				
				dispatch(getAllUsers(updateUser))
				toast.success("User updated successfully!");
			} else {
				setAlertType("error");
				setAlertMessage(json.msg || "Error in update user");
				toast.error(json.msg || "Unable to update user!");
				// await dispatch(getAllUsers())
			}
			// console.log(response);
		} catch (error) {
			setAlertType("error");
			setAlertMessage(error);
			toast.error("Unable to update user!");
		}
	};

	const handleChange = (event) => {
		setError((prev) => ({
			...prev,
			role_error: event.target.value ? false : "Please select a role.",
		}));
		setRole(event.target.value);
		setnewUser({ ...newUser, ["user_roleid"]: `${event.target.value}` });
	};

	const handleEmail = (e) => {
		handleTextFieldChange(e);
		setError((prev) => ({
			...prev,
			email_error: !e.target.value
				? "Email is required."
				: !EmailValidator.validate(e.target.value)
					? "Invalid Email: Enter valid email"
					: false,
		}));
	};

	const handleMobile = (e) => {
		handleTextFieldChange(e);
		if (e.target.value.length === 10) {
			e.target.value = parseInt(e.target.value);
			handleTextFieldChange(e);
			setError((prev) => ({ ...prev, mobile_error: false }));
		} else {
			setError((prev) => ({
				...prev,
				mobile_error: !e.target.value ? "Mobile number is required." : "Error: Number must be 10 number",
			}));
		}
	};

	const handlePassword = (e) => {
		handleTextFieldChange(e);
		if (e.target.value.length < 6) {
			setError({
				...error,
				["password_error"]: "Error: Password length must be greator 6",
			});
		} else {
			setError({ ...error, ["password_error"]: false });
		}
	};

	const handleDeletePopUp = (id) => {
		setDeletePopUp(true);
		localStorage.setItem("deleteUserId", id);
		const selectedUser = users.find((item) => item.user_id === id);
		setDeleteUserName(selectedUser?.user_name || "");
	}


	const handleShow = (data) => {
		setShowData(data);
		setShowModal(true);
	}

	const statCards = [
		{ label: "SUPER ADMIN", total: totalSuperAdmin.length, icon: Person },
		{ label: "ADMIN", total: totalAdmin.length, icon: SupervisorAccountIcon },
		{ label: "ALLIANCE AGENT", total: totalAlliance.length, icon: AccessibilityIcon },
		{ label: "CAMPAIGN MANAGER", total: totalCampaign.length, icon: ManageAccountsIcon },
		{ label: "AUDIT MANAGER", total: totalAudit.length, icon: VerifiedUserIcon },
		{ label: "TOTAL USERS", total: totalUser, icon: PeopleAltIcon },
	];

	return (
		<Container className='user-management'>
			<Grid container direction='column' spacing={5}>
				<Grid
					container
					item
					direction='row'
					alignItems='center'
					justifyContent='space-between'
					className='user-management-head'
				>
					<motion.div
						initial={{ opacity: 0, y: -14 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.45 }}
						className='user-management-intro'
					>
						<h2>User Management</h2>
						<p>Track users by role and manage access in one place.</p>
						</motion.div>
						<div className='user-stat-grid'>
							{statCards.map((item, idx) => {
								const Icon = item.icon;
								return (
									<motion.div
										key={item.label}
										className='user-metric-card'
										initial={{ opacity: 0, y: 18 }}
										animate={{ opacity: 1, y: 0 }}
										transition={{ duration: 0.4, delay: idx * 0.05, ease: "easeOut" }}
										whileHover={{ y: -4, scale: 1.02 }}
									>
										<div className='user-metric-head'>
											<div className='user-metric-icon-wrap'>
												<Icon className='user-metric-icon' />
											</div>
											<span className='user-metric-label'>{item.label}</span>
										</div>
										<div className='user-metric-values'>
											<p>
												<span>Total</span>
												<CountUp end={item.total} duration={1.1} separator="," />
											</p>
										</div>
									</motion.div>
								);
							})}
						</div>
					</Grid>

				<Grid item>
					{user_roleid === 1 && (
						<div className='user-create-card'>
							<CreateCampaignCard
								onClick={handleClickOpen}
								btnText={"Add User"}
								heading={"Users"}
								subHeading={"Manage users and access controls"}
							/>
						</div>
					)}
						{user_roleid !== 6 && (
							<Box sx={{ flexGrow: 1, mt: 3 }} className='user-cards-wrap user-cards-grid'>
									<motion.div
									className='user-list-head'
									initial={{ opacity: 0, y: 10 }}
									animate={{ opacity: 1, y: 0 }}
									transition={{ duration: 0.35, ease: "easeOut" }}
								>
									<h3>Team Directory</h3>
									<span>{totalUser} users</span>
								</motion.div>
								<Grid
									item
									container
									direction='row'
									spacing={{ xs: 0, md: 1 }}
									columns={{ xs: 4, sm: 8, md: 12 }}>
									{users.length === 0 && (
										<Grid item xs={12}>
											<div className='user-empty-state'>No users available right now.</div>
										</Grid>
									)}
									{users.map((element, index) => {
										return (
											<Grid item xs={4} sm={4} md={4} key={index}>
												<motion.div
													initial={{ opacity: 0, y: 18 }}
													animate={{ opacity: 1, y: 0 }}
												transition={{ duration: 0.42, delay: index * 0.05, ease: "easeOut" }}
											>
											<UserCard
												key={element.user_id}
												users={element}
												update={updateUser}
												deleteUser={handleDeletePopUp}
												handleShow={handleShow}
												roles={roles}
											/>
											</motion.div>
										</Grid>
									);
								})}
							</Grid>
						</Box>
					)}
				</Grid>
			</Grid>

			<UserDialog
				open={open}
				handleClose={handleClose}
				handleTextFieldChange={handleTextFieldChange}
				handleEmail={handleEmail}
				handleMobile={handleMobile}
				handlePassword={handlePassword}
				handleChange={handleChange}
				createUser={createUser}
				newUser={newUser}
				error={error}
				action={action}
				roles={roles}
				role={role}
				alertType={alertType}
				alertMessage={alertMessage}
				dialogTitle={dialogTitle}
			/>
			<MessageDialog
				open={deletePopUp}
				onClose={() => {
					setDeletePopUp(false);
					setDeleteUserName("");
				}}
				title="Delete User"
				message={
					<>
						Are you sure you want to delete{" "}
						<span
							style={{
								fontWeight: 700,
								color: "#be123c",
								background: "rgba(244, 63, 94, 0.12)",
								padding: "2px 8px",
								borderRadius: "8px",
								display: "inline-block",
							}}
						>
							{deleteUserName || "this user"}
						</span>
						?
					</>
				}
				okText={`Delete`}
				variant={"error"}
				onConfirm={deleteUser}
			/>

			<ShowUserModal
				isOpen={showModal}
				onClose={() => setShowModal(false)}
				user={showData}
			/>
		</Container>
	);
};

export default UserManagement;
